import React from 'react';
import { useStowageStore } from 'src/context/StowageContext';
import ViolationListContextMenu from './ViolationListContextMenu';
import { ViolationMenuWrapper } from './ViolationListView.styles';

const ViolationListContextMenuWrapperComponent: React.FC = () => {
    const { violationListContextMenuState } = useStowageStore();

    return (
        <ViolationMenuWrapper>
            {violationListContextMenuState?.visible && <ViolationListContextMenu contextMenuState={violationListContextMenuState} />}
        </ViolationMenuWrapper>
    );
};

export default ViolationListContextMenuWrapperComponent;
